import clearIsDirty from '../../actions/clearIsDirty';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import QuickActionsViewState from '../../store/schema/QuickActionsViewState';
import saveQuickActionsOption from '../../actions/quickActions/saveQuickActionsOption';
import { updateUserConfigurationService } from 'owa-session-store/lib/services/updateUserConfigurationService';
import updateUserOptions from '../../utils/updateUserOptions';
import { getOptionsStore } from '../../store/Store';
import { hideFullScreenSpinner, showFullScreenSpinner } from 'mini-full-screen-spinner';
import { MAIL_LEFT_SWIPE_ACTION, MAIL_RIGHT_SWIPE_ACTION } from '../../utils/constants';
import { orchestrator } from 'satcheljs';
import getUserConfigurationChangesDictionary, {
    AlternateKeyNamesMapType,
    OptionsViewStateKeyType,
} from '../../utils/getUserConfigurationChangesDictionary';

const saveQuickActionsOptionOrchestrator = orchestrator(
    saveQuickActionsOption,
    async (actionMessage: {}) => {
        const optionsStore = getOptionsStore();
        if (optionsStore && optionsStore.activeViewState) {
            const viewState = optionsStore.activeViewState as QuickActionsViewState;
            const { leftSwipeAction, rightSwipeAction } = viewState;
            const configuration = getUserConfiguration().ViewStateConfiguration;

            const changedKeys: OptionsViewStateKeyType[] = [];
            const alternateKeyNames: AlternateKeyNamesMapType = {};

            if (configuration.MailLeftSwipeAction !== leftSwipeAction) {
                changedKeys.push('leftSwipeAction');
                alternateKeyNames.leftSwipeAction = MAIL_LEFT_SWIPE_ACTION;
            }
            if (configuration.MailRightSwipeAction !== rightSwipeAction) {
                changedKeys.push('rightSwipeAction');
                alternateKeyNames.rightSwipeAction = MAIL_RIGHT_SWIPE_ACTION;
            }

            if (changedKeys.length) {
                // start the spinner
                showFullScreenSpinner();

                // perform the update
                const changesDict = getUserConfigurationChangesDictionary(
                    viewState,
                    changedKeys,
                    alternateKeyNames
                );

                const response = await updateUserConfigurationService(
                    changesDict,
                    'OWA.ViewStateConfiguration'
                );

                // update the configuration if we have a success and clear the flag
                if (
                    response &&
                    response.Body &&
                    response.Body.ResponseMessages &&
                    response.Body.ResponseMessages.Items &&
                    response.Body.ResponseMessages.Items.length &&
                    response.Body.ResponseMessages.Items[0] &&
                    response.Body.ResponseMessages.Items[0].ResponseClass === 'Success'
                ) {
                    updateUserOptions({
                        ViewStateConfiguration: {
                            MailLeftSwipeAction: leftSwipeAction,
                            MailRightSwipeAction: rightSwipeAction,
                        },
                    } as OwaUserConfiguration);
                    clearIsDirty(); // clear the flag only on a success so that the save button is disabled only on a success
                }

                // remove the spinner
                hideFullScreenSpinner();
            }
        }
    }
);

export default saveQuickActionsOptionOrchestrator;
